import React, { lazy } from 'react';

const CardComponent = lazy(() => import('../../Cards/Card'));
const BlogCard = lazy(() => import('../../Cards/BlogCard'));
const LearningCard = lazy(() => import('../../Cards/LearningCard'));
const ChecklistCard = lazy(() => import('../../Cards/ChecklistCard/index'));
const ProductReleaseCard = lazy(() => import('../../Cards/ProductReleaseCard'));
const PartnershipsCard = lazy(() => import('../../Cards/PartnershipsCard'));
const EventCard = lazy(() => import('../../Cards/EventCard'));

const Card = ({ post, type }) => {
  switch (type) {
    case 'blog':
      return <BlogCard {...post} />;
    case 'events':
      return <EventCard data={post} />;
    case 'learning':
      return <LearningCard {...post} />;
    case 'checklists':
      return <ChecklistCard {...post} />;
    case 'product-release':
      return <ProductReleaseCard {...post} />;
    case 'partnerships':
      return <PartnershipsCard {...post} />;
    case 'press':
      return (
        <CardComponent
          card={{
            theme: 'blue-hover-gradient',
            thumbnail: post?.source?.logo,
            headingKicker: post?.source?.name,
            subhead: post?.title,
            callToAction: post?.callToAction,
          }}
        />
      );
    default:
      return null;
  }
};

export default Card;
